import { createReducer } from "sc/helpers/reducer";
import { PARTNERS_PAGE_LOAD, PARTNERS_LOADED } from "../actions/partners";
import { LOGOUT } from "../actions/auth";

export default createReducer(null, {
  [LOGOUT]: (state, action) => null,
  [PARTNERS_LOADED]: (state, action) => action.payload.partners,
  [PARTNERS_PAGE_LOAD]: (state, action) => null,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/partners-reducer.js